<template>
  <div class="dashboard">
    <div class="welmsg">
      <el-icon size="16"><coffee-cup /></el-icon>
      您好：<span class="impor">{{$store.state.admin.relname||''}}</span>，欢迎使用郑嫂广雅管理系统！
      <a href="javascript:void(0)" class="loginout" @click="loginout">退出登录</a>
      <a href="javascript:void(0)" class="editpwd" @click="OpenUrl('/selfpwd')">修改密码</a>
    </div>
    <div class="user-out">
      <div :class="[row.otot>0?'hasorder':'','userls']" v-for="(row,key) in data.data" :key="key">
        <div class="tagtop">
          <div class="tago" @click="seeOrder(row)">{{row.otot>0?'已下单':'未下单'}}</div>

<!--           <div class="tago" ><el-icon> <ShoppingCartFull></ShoppingCartFull></el-icon></div>
 -->          <el-tag v-if="row.agree_warning" class="warntag" type="danger" effect="dark" round size="small">待续签</el-tag>
        </div>
        <div class="uname">{{row.line_name_min}}-{{row.uname}}</div>
        <div class="uinfo">{{row.link_man}} / {{row.link_phone}}</div>
        <el-icon color="#ffffff" size="16" class="addcart" title="代客下单" alt="代客下单" v-if="checkBtn(powerbtn,'make_order')"  @click="makeOrder(row)"><ShoppingCart /></el-icon>
      </div>
    </div>
    <div class="main-foot">
      <el-select v-model="search.way_id" @change="do_search" style="float: left; width: 130px;">
        <el-option label="全部线路" :value="0"></el-option>
        <el-option v-for="(p,k) in waylist" :key="k" :label="p.line_name" :value="p.id.toString()"></el-option>
      </el-select>
      <el-pagination background layout="total,prev,pager,next,sizes" :total="data.total" v-model:currentPage="data.current_page" :page-size="search.pageSize" :page-sizes="pageSizeOpts(20)" @size-change="pageSizeChange" @current-change="pageChange">
      </el-pagination>
    </div>
    <make-order ref="morder"></make-order>
    <show-order ref="sorder"></show-order>
  </div>
</template>
<script>
import MakeOrder from "@/components/order/order"
import ShowOrder from "@/components/order/showOrder"
export default {
  name: 'DashboardPage',
  components:{MakeOrder,ShowOrder},
  data:function(){
    return {
      data:{data:[],total:0,current_page:1},
      search:{
        way_id:0,
        page:1,
        pageSize:20,
      },
      waylist: {},
      powerbtn:[]
    }
  },
  created:function(){
    var _this = this;
    _this.init();
    setInterval(function (){
      _this.init();
    },60000);
  },
  methods:{
    /**
     * 初始化参数
     */
    init:function(){
      var _this = this;
      _this.RequestApi('remind_dashboard.html',this.search).then(function (res){
        if(res.status==1){
          _this.data = res.data;
          _this.waylist=res.waylist;
          _this.powerbtn = res.powerbtn;
        }
      });
    },
    /**
     * 退出登录
     */
    loginout:function (){
      var _this=this;
      _this.confirm('确定要退出系统吗？',function(){
        _this.RequestApi('login_out.html').then(function (res){
          if(res.status==1){
            localStorage.removeItem('qfyutoken');
            localStorage.removeItem('routemap');
            _this.OpenUrl('/login');
            _this.TipSuccess(res.msg);
          }else{
            _this.TipsError(res.msg);
          }
        });
      });
    },
    /**
     * 打开代客下单窗口
     */
    makeOrder(user){
      this.$refs.morder.init(user);
    },
    /**
     * 打开客户当天订单窗口
     */
    seeOrder(item){
      this.$refs.sorder.init3(item);
    },
    do_search(){
      this.search.page=1;
      this.init();
    },
    /**
     * 翻页
     */
    pageChange:function (page){
      this.search.page=page;
      this.init();
    },
    /**
     * 设置每页条数
     */
    pageSizeChange:function (pageSize){
      this.search.pageSize=pageSize;
      this.search.page=1;
      this.init();
    },
  }
}
</script>
<style lang="less">
@import "~@/assets/css/dashboard/index";
@import "~@/assets/css/dashboard/tips";
</style>